import React, {Component} from 'react';
import {Row, Navbar, Nav} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';
import Scrollchor from 'react-scrollchor';

//Imagenes
import logo from '../../../assets/img/myflogo-red.png';
import carrito from '../../../assets/img/carrito1.png';
import volver from '../../../assets/img/volver.png';


class PromocionesNavBar extends Component {

    constructor(props) {
        super(props);
        this.state = {barra: "false", abierto: false};
    }

    cerrar() {
        this.setState({abierto: false});
    }

    onToggle() {
        this.setState({abierto: !this.state.abierto});
    }


    render() {

        return (
            <Row>
                <Navbar inverse
                        collapseOnSelect
                        fixedTop
                        className="promo-header"
                        expanded={this.state.abierto}
                        onToggle={(e) => this.onToggle()} onBlur={(e) => this.cerrar()}
                >
                    <Navbar.Brand>
                        <NavLink to="/">
                            <img className="img-responsive" src={logo} alt="MyF-Distribuciones"/>
                        </NavLink>
                    </Navbar.Brand>
                    <Navbar.Toggle/>
                    <Navbar.Collapse>
                        <Nav pullRight>
                            <li className="promo-volver">
                                <NavLink to="/" onClick={(e) => this.cerrar()}>
                                    <img src={volver} alt="inicio-myf"/>
                                    Volver
                                </NavLink>
                            </li>
                            <li>
                                <Scrollchor to="#actuales" onClick={(e) => this.cerrar()}>
                                    Promociones
                                </Scrollchor>
                            </li>
                            {/*<li className="promo-carrito">*/}
                            {/*    <a onClick={(e) => this.cerrar()}*/}
                            {/*       href="http://carrito.myfdistribuciones.com.ar/sk2.myf"*/}
                            {/*       target="_blank"*/}
                            {/*    >*/}
                            {/*        <img src={carrito}*/}
                            {/*             alt="carrito-compras"/>*/}
                            {/*    </a>*/}
                            {/*</li>*/}
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </Row>
        );
    }
}


export default PromocionesNavBar;


// WEBPACK FOOTER //
// ./src/pages/Promociones/PromocionesSubComponents/PromocionesNavBar.js